import { Component, OnInit } from '@angular/core';
import { HasPermissionService } from '../../service/has-permission/has-permission.service';
import { Message, ConfirmationService, LazyLoadEvent, CalendarModule, ToggleButtonModule, SelectItem } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';
import { formatDate } from '../../../../theme/functions/formatDate.function';

import {
    isSameMonth,
    isSameDay,
    startOfMonth,
    endOfMonth,
    startOfWeek,
    endOfWeek,
    startOfDay,
    endOfDay,
    format
} from 'date-fns';
import { CalendarEvent } from 'angular-calendar';
import { ScheduleEmployee } from '../../class/schedule-employee';
import { ActivatedRoute, Router } from '@angular/router';
import { ScheduleEmployeeService} from '../../service/schedule-employee/scheduleEmployee.service';
import { NewnessService } from '../../service/newness/newness.service';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Newness } from '../../class/newness';
import { OpeningStation } from '../../class/opening-station';
import { config } from '../../../../../environments/config';
import { filter } from 'rxjs/operator/filter';
import { NotificationsService } from '../../../../theme/services/notifications/notifications.service';
import { UploadFilesService } from '../../service/upload-files/upload-files.service';
import { calendarES } from '../../../../theme/functions/calendarES';

@Component({
  selector: 'app-schedule-employees',
  templateUrl: './schedule-employees.component.html',
  styleUrls: ['./schedule-employees.component.scss']
})
export class ScheduleEmployeesComponent implements OnInit {
    public promiseForm: Promise<any>;

    public msgs: Message[] = [];
    edit: ScheduleEmployee;
    // location_url: Location;
    public form: FormGroup;
    public employee_id: AbstractControl;
    public form3: FormGroup;
    
    public location: AbstractControl;
    public recurrent: AbstractControl;
    public created_at: AbstractControl;
    public start: AbstractControl;
    public end: AbstractControl;
    public choose_days: AbstractControl;
    public allDay: AbstractControl;
    public color: AbstractControl;
    public textColor: AbstractControl;
    public status: AbstractControl;

    // public all_day: AbstractControl;
    public approved: AbstractControl;
    public processed: AbstractControl;
    public observation: AbstractControl;
    
    public employee_id_filter: AbstractControl;
    public location_filter: AbstractControl;
    public department_id_filter: AbstractControl;
    public venue_id_filter: AbstractControl;
    
    
    public listPending: any;
    public listProgress: any;
    public listDone: any;

    public listNewness: any[];

    public workLocations: any[];
    public viewType: string;

    public visibleSidebar2: boolean;

    public first = 0;

    public eventID: Number = 0;
    public modNew = false;
    public modView = false;
    public openScheduleEmployee = false;
    public header: any;
    public scheduleEmployeeList: ScheduleEmployee[];
    public scheduleEmployeeCalendar: any[];
    public scheduleEmployeeKanban: ScheduleEmployee[];
    public scheduleEmployeeType: string;
    public filters: {key: string, value: string}[];
    public filtersCalendar: {key: string, value: string}[];
    public filtersKanban: {key: string, value: string}[];
    public queryEvent: string;
    public query: string;

    public totalRecords: number;
    public totalRecordsNewness: number;
    public page: number;
    public per_page: number;
    public sort: string;
    public es: any;

    public minDate: Date;

    public optionsSelectionStatusScheduleEmployee: any[];
    public optionsSelectionRecurrent: any[];

    public calendarStart: string;
    public calendarEnd: string;

    public kanbanStart: string;
    public kanbanEnd: string;

    public selectOpeningStation: OpeningStation;

    public types: SelectItem[];

    public employeePosition: string;
    public employeePositionCreatedBy: string;
    public employeePositionCompletedBy: string;

    public modExportDialog: boolean;

    public apiUrl = config.API_ROOT;

    public ReportTypeExportOptions: SelectItem[];
    public selectedReportTypeExportOptions: {label: string, value: string};

    public form4: FormGroup;
    
    public f4_date_start: AbstractControl;
    public f4_date_end: AbstractControl;
    public f4_status_filter: AbstractControl;
    public f4_export_type_filter: AbstractControl;
    public locationOptions: SelectItem[];

    public form5: FormGroup;
    public f5_date_start: AbstractControl;
    public f5_date_end: AbstractControl;
    
    public f5_employee_id: AbstractControl;
    
    public f5_type_filter: AbstractControl;
    public f5_export_filter: AbstractControl;

    public exportOptions: SelectItem[];

    public modViewDialogStation: boolean;
    public modViewDialogUploadSchedule: boolean = false;
    public loading_upload: boolean = false;
    public schedulesUploadResult: any;
    public schedulesUploadResultStatus : number=0;
    public lengthSchedulesUploadResult : number=0;
    // public vallday: boolean;
    
    public sticky: boolean;
    public days: any[];
    public selectedDays: any[];
    params_id_schedule_employee: number;
    

    constructor(
        fb: FormBuilder,
        public scheduleEmployeeService: ScheduleEmployeeService,
        public newnessService: NewnessService,
        public confirmationService: ConfirmationService,
        public hasPermissionService: HasPermissionService,
        public translate: TranslateService,
        private route: ActivatedRoute,
        private notificationsService: NotificationsService,
        public uploadFilesService: UploadFilesService,
        public activatedRoute: ActivatedRoute,
        // location_url: Location,
        private router: Router) {
            // this.location_url = location_url;
            this.modExportDialog = false;

            this.employeePosition = '2';
            this.employeePositionCreatedBy = '3';
            this.employeePositionCompletedBy = '2,3,4';

            

            this.exportOptions = [
                {label: 'Excel', value: 'excel'},
            ];

            
            this.optionsSelectionRecurrent = [];
            this.optionsSelectionRecurrent.push({label: 'Sí', value: '1'});
            this.optionsSelectionRecurrent.push({label: 'No', value: '0'});
            

            this.form = fb.group({
                'location': ['', Validators.compose([Validators.required, Validators.minLength(1)])],
                'recurrent': [''],
                'created_at': [''],
                'start': ['', Validators.compose([Validators.required, Validators.minLength(1)])],
                'end': [''],
                'allDay': [''],
                'color': [''],
                'textColor': [''],
                'employee_id':['', Validators.compose([Validators.required, Validators.minLength(1)])],
                'choose_days':[''],
                'all_day': [''],
                'approved':[''],
                'processed':[''],
                'observation':[''],
                
            });
            this.location = this.form.controls['location'];
            this.recurrent = this.form.controls['recurrent'];
            this.created_at = this.form.controls['created_at'];
            this.start = this.form.controls['start'];
            this.end = this.form.controls['end'];
            this.allDay = this.form.controls['allDay'];
            this.color = this.form.controls['color'];
            this.textColor = this.form.controls['textColor'];
            // this.status = this.form.controls['status'];
            this.employee_id = this.form.controls['employee_id'];
            this.choose_days = this.form.controls['choose_days'];
            // this.all_day = this.form.controls['all_day'];
            this.approved= this.form.controls['approved'];
            this.processed= this.form.controls['processed'];
            this.observation = this.form.controls['observation'];
            

            this.form3 = fb.group({
                // 'station_id_filter': [''],
                'employee_id_filter': [''],
                // 'created_by_filter': [''],
                // 'completed_by_filter': [''],
                // 'type_id_filter': [''],
                'location_filter': [''],
                'department_id_filter':[''],
                'venue_id_filter':['']
            });
            this.employee_id_filter = this.form3.controls['employee_id_filter'];
            this.location_filter = this.form3.controls['location_filter'];
            this.department_id_filter= this.form3.controls['department_id_filter'];
            this.venue_id_filter= this.form3.controls['venue_id_filter'];
            // this.created_by_filter = this.form3.controls['created_by_filter'];
            
            this.form4 = fb.group({
                'f4_date_start': ['', [Validators.required]],
                'f4_date_end': ['', [Validators.required]],
                'f4_status_filter': [''],
                'f4_export_type_filter': [''],

            });

            this.f4_date_start = this.form4.controls['f4_date_start'];
            this.f4_date_end = this.form4.controls['f4_date_end'];
            this.f4_status_filter = this.form4.controls['f4_status_filter'];
            this.f4_export_type_filter = this.form4.controls['f4_export_type_filter'];
            
            // this.f4_status_filter.setValue('all');
            this.modExportDialog = false;

            // this.locationOptions = [
            //     {label: 'Todos', value: 'all'},
            //     {label: 'Activos', value: 'Activos'},
            //     {label: 'Retirado', value: 'Retirado'},
            // ];

            this.form5 = fb.group({
                'f5_date_start': ['', [Validators.required]],
                'f5_date_end': ['', [Validators.required]],
                
                'f5_employee_id': [''],
                
                'f5_type_filter': [''],
                'f5_export_filter': [''],
            });
            this.f5_date_start = this.form5.controls['f5_date_start'];
            this.f5_date_end = this.form5.controls['f5_date_end'];
            this.f5_employee_id = this.form5.controls['f5_employee_id'];
            this.f5_type_filter = this.form5.controls['f5_type_filter'];
            this.f5_export_filter = this.form5.controls['f5_export_filter'];
            // this.f5_type_filter.setValue('all');
            // this.f5_export_filter.setValue('excel');

            // this.minDate = new Date();
            // this.start.setValue(this.minDate);

            this.listNewness = [];

            this.modViewDialogStation = false;
            this.sticky = false;
    }

    ngOnInit() {
        const dateStart = new Date();
        const dateEnd = new Date();
        dateStart.setHours(23, 59, 59, 59);
        dateEnd.setHours(0, 0, 0, 0);
        this.kanbanStart = dateStart.toISOString();
        this.kanbanEnd = dateEnd.toISOString();
        this.es = calendarES();
        this.days= [{label: 'dom', value:0}, {label:'lun', value:1}, {label:'mar', value:2}, {label:'mié', value:3}, {label:'jue', value:4}, {label:'vie', value:5}, {label:'sáb', value:6}];
        this.workLocations=[{label: 'Oficina', value:'Oficina'},{label: 'Casa', value:'Casa'},
                            {label: 'Empresa Cliente', value:'Empresa Cliente'},
                            {label: 'Permiso Remunerado', value:'Permiso Remunerado'},
                            {label: 'Permiso No Remunerado', value:'Permiso No Remunerado'},
                            {label: 'Licencia', value:'Licencia'},
                            {label: 'Vacaciones', value:'Vacaciones'},
                            {label: 'Incapacidad', value:'Incapacidad'},
                            {label: 'Sanción', value:'Sanción'}];    
        this.scheduleEmployeeList = [];
        this.scheduleEmployeeCalendar = [];
        this.scheduleEmployeeKanban = [];
        this.header = {
            left: 'prev,next today',
            center: 'title',
            right: 'month,agendaWeek,agendaDay,listDay'
        };

        this.page = 1;
        this.per_page = 1000;

        this.viewType = 'calendar';

        

        this.activatedRoute.queryParams.subscribe(params => {
            if (params['id_schedule_employee']) {
                this.params_id_schedule_employee = Number(params['id_schedule_employee']);
                this.filters = [];
                // this.filters.push({key: 'id', value: String(this.params_id_schedule_employee)});
                this.getScheduleEmployeeById(this.params_id_schedule_employee);//this.getRadicationSSsById(this.query, filters);
                this.router.navigate(
                    ['.'], 
                    { relativeTo: this.route, queryParams: {} }
                  );
            } 
            else {}
                // this.filter();
            //}
        });
        
    }

    public onChangeType($event) {
        if ($event === 'other') {
            this.location.setValue('Otro');
        } else {
            this.location.setValue($event);
        }
    }

    public loadEventLazy(event: LazyLoadEvent) {
        this.page = (event.first / this.per_page) + 1;
        
        if (event.sortField) {
            if (event.sortOrder === -1) {
                this.sort = '-' + event.sortField;
            } else {
                this.sort = event.sortField;
            }
        } else {
            this.sort = '-created_at';
        }

        if (event.globalFilter) {
            this.query = event.globalFilter;
        } else {
            this.query = undefined;
        }

        if (event.globalFilter) {
            this.query = event.globalFilter;
        } else {
            this.query = undefined;
        }

        if (this.viewType === 'list') {
            this.getEvent();
        }
        if (this.viewType === 'calendar') {
            this.getEventCalendar();
        }
        // if (this.viewType === 'kanban') {
        //     this.getEventKanban();
        // }

        // this.reloadListKanban();
    }

    // public loadEventLazy(event: LazyLoadEvent) {
    //     this.page = (event.first / this.per_page) + 1;
    //     if (event.sortOrder === -1) {
    //         this.sort =  '-' + event.sortField;
    //     } else {
    //         this.sort =  event.sortField;
    //     }
    //     this.getEvent(event.globalFilter);
    // }
    // 'start': (this.recurrent.value!='1') ? values.start.toISOString():null,
    //         'end': (this.recurrent.value!='1') ? values.end.toISOString():null,
    //         'startRecur': (this.recurrent.value=='1') ? values.start:null,
    //         'endRecur': (this.recurrent.value=='1') ? values.end:null,
    public newEvent(values: any) {
        var approved=false;
        var processed=false;
        // if(this.edit && (this.location.value=='Permiso No Remunerado' || this.location.value=='Permiso No Remunerado')){

        // }
        if(this.location.value!='Permiso Remunerado' && this.location.value!='Permiso No Remunerado'
            && this.location.value!='Licencia' && this.location.value!='Vacaciones' && this.location.value!='Incapacidad')
        {
            approved=true;
            processed=true;
        }
        else{
            if(this.hasPermission('get schedule-employee notification') && this.edit)
            {    
                approved=this.approved.value;
                processed=this.processed.value;
            }
            // else
            // { 
            //     approved=false;
            //     processed=false;   
            // }
        }
        const param = {
            'title': this.location.value,
            'location': this.location.value,
            'start': this.formatDateSave(values.start,1),//values.start,
            'end':  values.end ? this.formatDateSave(values.end,1):null,
            'startRecur': null,
            'endRecur': null,
            'allDay': values.allDay,
            'employee_id': values.employee_id.id,
            'daysOfWeek': values.choose_days,
            'approved': approved,
            'processed': processed,
            'observation': this.observation.value,
        };
        if (values && this.form.valid) {
            const promise = (this.edit) ?
                this.scheduleEmployeeService.updateScheduleEmployee(this.edit.id, param)
                :
                this.scheduleEmployeeService.newScheduleEmployee(param);

            this.promiseForm = promise.toPromise().then(
                response => {
                    if (this.viewType === 'list') {
                        this.getEvent();
                    }
                    if (this.viewType === 'calendar') {
                        this.getEventCalendar();
                    }
                    // if (this.viewType === 'kanban') {
                    //     this.getEventKanban();
                    // }
                        
                    // this.reloadListKanban();
                                this.translate.get('saved').subscribe((res: string) => {
                        this.msgs = [];
                        this.msgs.push( { severity: 'success', summary: res  } );
                        this.form.reset();
                    });
                    this.visibleSidebar2 = false;
                },
                error => {
                    if (this.viewType === 'list') {
                        this.getEvent();
                    }
                    if (this.viewType === 'calendar') {
                        this.getEventCalendar();
                    }
                    // if (this.viewType === 'kanban') {
                    //     this.getEventKanban();
                    // }
            
                    // this.reloadListKanban();
                                this.msgs = [];
                    this.msgs.push( { severity: 'error', summary: 'Error' } );
                }
            );
        }
    }

    public newNewness(values: Newness) {
        const param = {
            information: values.information,
            event_id: this.edit.id
        };
        if (values && this.form.valid) {
            const promise = this.newnessService.newNewness(this.edit.id, param);

            this.promiseForm = promise.toPromise().then(
                response => {
                    // this.getNewness(this.edit.id);
                    this.translate.get('saved').subscribe((res: string) => {
                        this.msgs = [];
                        this.msgs.push( { severity: 'success', summary: res  } );
                        // this.form.reset();
                    });
                },
                error => {
                    if (this.viewType === 'list') {
                        this.getEvent();
                    }
                    if (this.viewType === 'calendar') {
                        this.getEventCalendar();
                    }
                    // if (this.viewType === 'kanban') {
                    //     this.getEventKanban();
                    // }
            
                    // this.reloadListKanban();
            
                    this.msgs = [];
                    this.msgs.push( { severity: 'error', summary: 'Error' } );
                }
            );
        }
    }

    
    getEvent() {
        this.scheduleEmployeeService.getScheduleEmployee(this.page, this.per_page, this.sort, this.query, this.filters).toPromise().then(
            response => {
                this.scheduleEmployeeList = response.json().data;
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    getEventCalendar() {
        this.scheduleEmployeeService.getScheduleEmployee(1, 3000, this.sort, undefined, this.filtersCalendar).toPromise().then(
            response => {
                this.scheduleEmployeeCalendar = response.json().data;
                this.reloadListCalendar();
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    

    public savedEvent(res) {
        this.msgs = [];
        this.msgs.push(res);
        this.edit = null;
        this.modNew = false;
        if (this.viewType === 'list') {
            this.getEvent();
        }
        if (this.viewType === 'calendar') {
            this.getEventCalendar();
        }
        // if (this.viewType === 'kanban') {
        //     this.getEventKanban();
        // }

        // this.reloadListKanban();
    }

    public cancelEvent () {
        this.edit = null;
        this.visibleSidebar2 = false;
        if (this.viewType === 'list') {
            this.getEvent();
        }
        if (this.viewType === 'calendar') {
            this.getEventCalendar();
        }
        // if (this.viewType === 'kanban') {
        //     this.getEventKanban();
        // }

        // this.reloadListKanban();
    }

    

    public deleteDialog(scheduleEmployee: ScheduleEmployee) {
        let message;
        this.translate.get('Do you want to delete?').subscribe((res: string) => {
            message = res;
        });

        let header;
        this.translate.get('Delete Confirmation').subscribe((res: string) => {
            header = res;
        });

        this.confirmationService.confirm({
            message: message,
            header: header,
            icon: 'fa fa-trash',
            accept: () => {
                this.delete(scheduleEmployee);
            }
        });
    }

    public delete(scheduleEmployee: ScheduleEmployee) {
        this.scheduleEmployeeService.deleteScheduleEmployee(scheduleEmployee.id).toPromise().then(
            response => {
                this.msgs = [];
                this.msgs.push( { severity: 'success', summary: 'deleted' } );
                if (this.viewType === 'list') {
                    this.getEvent();
                }
                if (this.viewType === 'calendar') {
                    this.getEventCalendar();
                }
                // if (this.viewType === 'kanban') {
                //     this.getEventKanban();
                // }
    
                // this.reloadListKanban();
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public activeEvent(scheduleEmployee: ScheduleEmployee) {
        this.putEvent(scheduleEmployee);
    }

    public putEvent(values: ScheduleEmployee) {
        const param = {
            // 'status': values.status,
            // 'activated': values.activated
        };
        if (values) {
            const promise = this.scheduleEmployeeService.updateScheduleEmployee(values.id, param);
            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.msgs = [];
                        this.msgs.push( { severity: 'success', summary: res  } );
                    });
                },
                error => {
                    this.msgs.push( { severity: 'error', summary: 'Error' } );
                }
            );
        }
    }

    

    public reloadListCalendar() {
        this.scheduleEmployeeCalendar.forEach(element => {
            element.textColor = '#FFFFFF';
            // element.color = '#ffc107';
            if (element.location === 'Oficina') {
                element.color = '#ffc107';
            }
            if (element.location === 'Casa') {
                element.color = '#17a2b8';
            }
            if (element.location === 'Empresa Cliente') {
                element.color = '#28a745';
            }
            if (element.location === 'Permiso Remunerado') {
                element.color = '#B6AD1A ';
            }
            if (element.location === 'Permiso No Remunerado') {
                element.color = '#C5E32D';
            }
            if (element.location === 'Licencia') {
                element.color = '#B61A9F';
            }
            if (element.location === 'Vacaciones') {
                element.color = '#FF0080';
            }
            if (element.location === 'Incapacidad') {
                element.color = '#a281a9';
            }
            element.title= element.location + " - "+ element.employee.name;
            // element.allDay=true;
            element.start=element.start.replace('Z','-05:00');
            if(element.end!=null && element.end!='')
                element.end=element.end.replace('Z','-05:00');
            // if (element.status === 'progress') {
            //     element.textColor = '#FFFFFF';
            //     element.color = '#17a2b8';
            // }

            // if (element.status === 'done') {
            //     element.textColor = '#FFFFFF';
            //     element.color = '#28a745';
            // }
            //element.allDay =true;
            // if(element.location=='Repetido')
            // {    
            //     element.daysOfWeek= [0,1,2];
                
            // }
            // this.translate.get(element.type).subscribe((res: string) => {
            //     element.title = '#' + element.id + ' - ' + res + ' - ';
            // });
            // element.groupId="REPETIDO",
            // console.log(element);
        });
        // this.scheduleEmployeeCalendar.push({
            
        //         daysOfWeek: [ '4' ],
        //         startTime: '10:45:00',
        //         endTime: '12:45:00'
            
        // });
    }

    public showNewEvent() {
        this.edit = null;
        this.form.reset();
        // this.vallday=false;
        this.allDay.setValue(true);
        this.visibleSidebar2 = true;
    }

    public showEvent(event) {
        this.visibleSidebar2 = true;
        this.edit = event;
        this.location.setValue(this.edit.location);
        // this.recurrent.setValue(this.edit.recurrent);
        // if (this.edit.start !== '' && this.edit.start !== null) {
        //     this.start.setValue(new Date(this.edit.start));
        // }
        // if (this.edit.end !== '' && this.edit.end !== null) {
        //     this.end.setValue(new Date(this.edit.end));
        // }
        this.created_at.setValue(new Date(this.edit.created_at));
        this.start.setValue(new Date(this.edit.start));
        this.allDay.setValue(this.edit.allDay);
        this.color.setValue(this.edit.color);
        this.textColor.setValue(this.edit.textColor);
        this.employee_id.setValue(this.edit.employee_id);
        if(this.edit.end!=null && this.edit.end!='') 
            this.end.setValue(new Date(this.edit.end));
        this.approved.setValue(this.edit.approved);
        this.processed.setValue(this.edit.processed);
        this.observation.setValue(this.edit.observation);
        // this.vallday=this.edit.allDay;
        // this.status.setValue(this.edit.status);
        // this.type.setValue(this.edit.type);
        
        

        let start;
        if (event.start) {
            if (event.start._i) {
                start = event.start._i;
            } else {
                start = event.start;
            }
        } else {
            start = '';
        }

        let end;
        if (event.end && event.end !== '') {
            if (event.end._i) {
                end = event.end._i;
            } else {
                end = event.end;
            }
        } else {
            end = '';
        }

        let text;
        // this.translate.get(event.type).subscribe((res: string) => {
        //     let start2;
        //     let end2;
        //     text = res + '\n ' + event.station.name;
        //     if (start) {
        //         start2 = formatDate(start);
        //         text = text + '\n Inicio: ' + start2;
        //     }
        //     if (end) {
        //         end2 = formatDate(end);
        //         text = text + '\n Fin: ' + end2;
        //     }
        //     // if (event.company) {
        //     //     text = text + '\n Compañía: ' + event.company;
        //     // }
        //     // if (event.contact) {
        //     //     text = text + '\n Contacto: ' + event.contact;
        //     // }
        //     // if (event.job) {
        //     //     text = text + '\n Trabajo: ' + event.job;
        //     // }
        //     // if (event.person_in) {
        //     //     text = text + '\n Quién Ingresa: ' + event.person_in;
        //     // }
        //     // if (event.identification_number) {
        //     //     text = text + '\n Id: ' + event.identification_number;
        //     // }
        // });

        
    }

    public listView() {
        this.getEvent();

        this.viewType = 'list';
    }

    public calendarView() {
        this.getEventCalendar();

        this.viewType = 'calendar';
    }

    

    handleEventClick(e) {
        var x=0;
        for(var i=0;i<this.scheduleEmployeeCalendar.length;i++){
            if(this.scheduleEmployeeCalendar[i].id==e.calEvent.id){
                x=i; 
                break;
            }
        }
        this.showEvent(this.scheduleEmployeeCalendar[x]);        
        // this.showEvent(e.calEvent);
    }

    public changeStartDate(event) {
        this.end.setValue('');
    }

    public findElement (list, search) {
        let find = -1;
        let itera = 0;
        list.forEach(element => {
            if (element.id === search) {
                find = itera;
            }
            itera++;
        });
        return find;
    }

    public cleanFormFilter() {
        this.form3.reset();
        this.employee_id_filter.setValue('');
        this.filter();
    }

    openWhatsapp(event) {
        window.open('https://api.whatsapp.com/send?phone=' + '57' + event.mobile_send + '&text=' + event.message_send, '_blank');
    }

    printToCart(printSectionId: string) {
        let popup;
        const innerContents = document.getElementById(printSectionId).innerHTML;
        popup = window.open('', '_blank', 'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
        popup.document.open();
        popup.document.write('<html>' +
                            '<head>' +
                            '<style>' +
                            '.fc-button-group { display: none;}' +
                            '.fc-left { display: none;}' +
                            '.fc-scroller { overflow-x: unset !important; overflow-y: unset !important;}' +
                            '</style>' +
                            '</head>' +
                            '<body onload="window.print()">' +
                            innerContents +
                            '</body>' +
                            '</html>');
        popup.document.close();
    }

    public checkStation (values) {
        let check = true;
        // if (values) {
        //     if (values.station_id) {
        //         if (values.station_id.id) {
        //             check = true;
        //         }
        //     }
        // }
        return check;
    }

    public formatDateSave(date,time_zone) {
        const d = new Date(date);
        let month = '' + (d.getMonth() + 1);
        let day = '' + d.getDate();
        const year = d.getFullYear();
        let hours = '' + d.getHours();
        let minutes = '' + d.getMinutes();
        let seconds = '' + d.getSeconds();
        let timezo= ''+ d.getTimezoneOffset();
        if (month.length < 2) {
            month = '0' + month;
        }
        if (day.length < 2) {
            day = '0' + day;
        }

        if (hours.length < 2) {
            hours = '0' + hours;
        }

        if (minutes.length < 2) {
            minutes = '0' + minutes;
        }

        if (seconds.length < 2) {
            seconds = '0' + seconds;
        }

        var ret =[year, month, day].join('-') + 'T' + [hours, minutes, seconds].join(':');
        if(time_zone)
            ret+=".000-05:00";
        return ret;    
    }
    public showExportDialog() {
        this.modExportDialog = true;
    }

    public cancelExport() {
        this.modExportDialog = false;
        this.edit= null;
    }

    public exportReport(values) {
        this.exportReportExcel(values);
    }

    public exportReportExcel(values) {
        const f4_date_start = formatDate(values.f4_date_start);
        const f4_date_end = formatDate(values.f4_date_end);

        let url = this.apiUrl + '/schedule-employees/excel?' +
        'token=' + localStorage.getItem('token') +
        '&_page=1&_sort=-id&';

        if (f4_date_start) {
            url = url + 'created_at-min=' + f4_date_start + '&';
        }

        if (f4_date_end) {
            url = url + 'created_at-max=' + f4_date_end + '&';
        }
        if (values.f4_status_filter){
            url = url + 'work_location=' + values.f4_status_filter;
        }
        

        console.log(url);
        window.open(url, '_blank');
    }

    public filterEvent (event, values) {
        this.filter(this.form3.value, event);
    }

    public hasPermission(permission) {
        return this.hasPermissionService.hasPermission(permission);
    }

    public filter (values?, event?) {
        this.filters = [];
        this.filtersCalendar = [];
        this.filtersKanban = [];
        this.first = 0;

        // if (this.route.snapshot.url[0].path === 'schedule-employees')  {
            
        //     // if (this.route.snapshot.url[1].path === 'event')  {
        //     //     this.eventType = 'manage-claro';
        //     //     this.filters.push({key: 'event_position_id', value: this.eventType});
        //     // }
        // }

        if (values) {
            // if (values.station_id_filter) {
            //     this.filters.push({'key': 'station_id-lk', 'value': values.station_id_filter.id});
            // }
            if (values.employee_id_filter) {
                this.filters.push({'key': 'employee_id-lk', 'value': values.employee_id_filter.id});
            }
            if (values.location_filter && values.location_filter!= "null") {
                this.filters.push({'key': 'location-lk', 'value': values.location_filter});
            }
            if (values.department_id_filter) {
                this.filters.push({'key': 'department_id', 'value': values.department_id_filter});
            }
            if (values.venue_id_filter) {
                this.filters.push({'key': 'venue_id', 'value': values.venue_id_filter});
            }
            // if (values.created_by_filter) {
            //     this.filters.push({'key': 'created_by_id-lk', 'value': values.created_by_filter.id});
            // }
            // if (values.completed_by_filter) {
            //     this.filters.push({'key': 'done_by_id-lk', 'value': values.completed_by_filter.id});
            // }
            // if (values.type_id_filter !== 'all' && values.type_id_filter !== '') {
            //     this.filters.push({'key': 'type-lk', 'value': values.type_id_filter});
            // } else if (values.type_id_filter == 'all' && !this.hasPermission('add management claro')){
            //     this.filters.push({'key': 'type-lk', 'value': 'activation,other'});
            // }
        }

        this.filters.forEach(element => {
            this.filtersCalendar.push({'key': element.key, 'value': element.value});
        });
        if (event) {
            this.calendarStart = new Date(event.view.start._d).toISOString();
            this.calendarEnd = new Date(event.view.end._d).toISOString();
            this.filtersCalendar.push({'key': 'start_min', 'value': this.calendarStart});
            this.filtersCalendar.push({'key': 'start_max', 'value': this.calendarEnd});
        } else if (this.calendarStart && this.calendarEnd) {
            this.filtersCalendar.push({'key': 'start_min', 'value': this.calendarStart});
            this.filtersCalendar.push({'key': 'start_max', 'value': this.calendarEnd});
        }

        this.filters.forEach(element => {
            this.filtersKanban.push({'key': element.key, 'value': element.value});
        });
        this.filtersKanban.push({'key': 'start_min', 'value': this.kanbanStart});
        this.filtersKanban.push({'key': 'start_max', 'value': this.kanbanEnd});


        this.query = undefined;

        if (this.viewType === 'list') {
            this.getEvent();
        }
        if (this.viewType === 'calendar') {
            this.getEventCalendar();
        }
        // if (this.viewType === 'kanban') {
        //     this.getEventKanban();
        // }

        // this.reloadListKanban();
    }
    public showUploadDialog() {
        this.modViewDialogUploadSchedule = true;
    }
    
    public cancelUpload() {
        this.modViewDialogUploadSchedule = false;
        this.getEventCalendar();
        // this.requisitionTrasnferOk=false;
        // this.requisitionTrasnfer=[];
        // this.resultSelectschedulesTransf=[];
        // this.lengthresultSelectschedulesTransf=0;
        // this.showrequisitionTransfer=false;
    }
    public attachmentUploadSchedules(event) {
        this.loading_upload=true;
        this.translate.get('uploading').subscribe((res: string) => {
            this.notificationsService.growlNotify('info', res + '...');
        });
        // this.translate.get('uploading').subscribe((res: string) => {
        //     this.msgs = [];
        //     this.msgs.push( { severity: 'info', summary: res  } );
        // });
        
        let uploadedAttachment = [];
        for (const file of event.files) {
            uploadedAttachment.push(file);
        }
            
        this.uploadFilesService.attachmentUploadSchedules(uploadedAttachment).toPromise().then(
            response => {
                this.loading_upload=false;
                this.schedulesUploadResult=response.json().data;
                this.schedulesUploadResultStatus =response.status;
                this.lengthSchedulesUploadResult= this.schedulesUploadResult.length;
                console.log("Documento subido excel");
                // this.translate.get('saved').subscribe((res: string) => {
                //     this.notificationsService.growlNotify('success', res);
                // });
                this.translate.get('saved').subscribe((res: string) => {
                    this.msgs = [];
                    this.msgs.push( { severity: 'success', summary: res  } );
                });
            },
            error => {
                this.loading_upload=false;
                let msg = '';
                this.schedulesUploadResult = error._body;
                this.schedulesUploadResultStatus = error.status;
                this.lengthSchedulesUploadResult= 0;
                this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                    this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                        JSON.parse(error._body).errors.forEach(element => {
                            if (element.source) {
                                if (element.source.pointer) {
                                    this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                        msg = msg + res3 + ', ';
                                    });
                                }
                            }
                        });
                        this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                    });
                });
            }
        );
    }

    public downloadTemplateSchedule()
    {
        window.open(this.apiUrl + '/schedule-employees/downloadTemplateSchedule'+ '?token=' + localStorage.getItem('token'));
    }
    getScheduleEmployeeById(id:number) {
        // this.loading = true;
        // this.scheduleEmployeeService.getScheduleEmployee(this.page, this.per_page, this.sort, this.query, this.filters).toPromise().then(
            this.scheduleEmployeeService.infoScheduleEmployee(id).toPromise().then(
            response => {
                this.showEvent(response.json());
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    // toggleVisibility(e)
    // {
    //     this.vallday=e;
    //     // console.log(this.marked);
    // }
    

    
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/schedule-employees/schedule-employees.component.ts